import { render, staticRenderFns } from "./SignaturesSection.vue?vue&type=template&id=10b0bb5b&scoped=true&"
import script from "./SignaturesSection.vue?vue&type=script&lang=js&"
export * from "./SignaturesSection.vue?vue&type=script&lang=js&"
import style0 from "./SignaturesSection.vue?vue&type=style&index=0&id=10b0bb5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0bb5b",
  null
  
)

export default component.exports